import {authHeader} from "@/helpers/authservice/auth-header";
import axios from "axios";

export function requiredHeaders() {
    var headers = {};
    Object.assign(headers, {
        'Content-Type': 'application/json',
        'authMethod': 'CUSTOM_JWT',
        Authorization: authHeader().Authorization
    });
    return headers;
}

const client_session_storage_key = "appClientSessionId";

export function getClientSessionId() {
    // sessionStorage -> per zakladka (polecane do blokad typu "Excel")
    let sid = sessionStorage.getItem(client_session_storage_key);
    if (!sid) {
        if (window.crypto && window.crypto.randomUUID) {
            sid = window.crypto.randomUUID();
        } else {
            // fallback gdyby randomUUID nie bylo dostepne
            sid = (Date.now() + "-" + Math.random().toString(16).slice(2));
        }
        sessionStorage.setItem(client_session_storage_key, sid);
    }
    return sid;
}

export function requiredHeadersWithClientSession() {
    const headers = requiredHeaders() || {};
    headers["X-Client-Session"] = getClientSessionId();
    return headers;
}
